module.exports = __webpack_public_path__ + "media/common/assignment-card-icon-661d545f.svg";